import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ClientModuleManagementComponent } from './client-module-management.component';


const routes: Routes = [
  {
    path: '',
    component: ClientModuleManagementComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClientModuleManagementRoutingModule { }
